export const MATCHA_JWT_HEADER = 'x-matcha-jwt' as const;

/**
 * Set by the client on a legacy `GET /api/jwt` fallback; value is a low-cardinality
 * reason. Observe counts it; enforce refuses the GET regardless of this header.
 */
export const MATCHA_POW_FALLBACK_HEADER = 'x-pow-fallback' as const;

/**
 * Client-emittable values for `MATCHA_POW_FALLBACK_HEADER`, one per failing sub-stage
 * so observe can separate, e.g., a worker-setup failure (`solve_worker`) from a real
 * main-thread solve failure (`solve_main`). Shared so the client (which emits these)
 * and the server (which allowlists them) stay in sync from one source. Lives in this
 * dependency-free module so the browser bundle never reaches into server-only `pow.ts`.
 * Low-cardinality — these are metric labels. The server additionally accepts legacy
 * coarse tags from pre-split clients (see `PowFallbackReason` in `pow.ts`).
 */
export const POW_FALLBACK_REASONS = [
  'challenge_fetch', // challenge GET threw (network/abort/offline)
  'challenge_http', // challenge GET returned a non-2xx, non-404
  'challenge_parse', // challenge 2xx body was not JSON
  'solve_worker', // worker solver threw or yielded no solution (setup/CSP/origin)
  'solve_main', // main-thread solver threw or yielded no solution
  'mint_http', // POST mint returned a non-2xx
  'mint_parse', // POST mint 2xx body was not JSON
] as const;

export type PowFallbackReason = (typeof POW_FALLBACK_REASONS)[number];

/** Client-reported solve time (ms) on a PoW `POST /api/jwt`. Untrusted; the server bounds it. */
export const MATCHA_POW_SOLVE_MS_HEADER = 'x-pow-solve-ms' as const;

/** Which solver produced the solution: `worker` (off-main-thread) or `main`. */
export const MATCHA_POW_SOLVE_PATH_HEADER = 'x-pow-solve-path' as const;
